export const buttonFacebookBox = () => {
    document.addEventListener("click", e => {
        const {target} = e;
        if(target.closest(".bsk-facebook-box__button")) {
            target.closest(".bsk-facebook-box").classList.toggle("bsk-facebook-box--active");
        }
        const bskFacebookBoxActive = document.querySelector(".bsk-facebook-box--active");
        if(bskFacebookBoxActive && !target.matches(".bsk-facebook-box *")) {
            bskFacebookBoxActive.classList.remove("bsk-facebook-box--active");
        }
    });

    const getCookie=n=>{
        const name=n+"=";
        return document.cookie.split(';').map(c=>c.trim()).find(c=>c.startsWith(name))?.substring(name.length)||null;
    };

    if(getCookie("cookie-fb") !== "true") {
        document.querySelectorAll(".bsk-facebook-box__fb-like-box").forEach(item => {
            item.innerHTML = `<p class="p-3">You have to accept<br>the cookies to see the Facebook plugin:<br><button class="bsk-btn-1 mt-3 ho-cookies-btn-cookies-bar--trigger">Cookies Settings</button></p>`;
        });
        return;
    }

    /* Facebook box */
    (function(d, s, id) {
        let js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s); js.id = id;
        js.src = "//connect.facebook.net/pl_PL/sdk.js#xfbml=1&appId=150620281795445&version=v2.0";
        fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
};
